import { Color } from '@tencent/alloy-renderer';

export function convertColor(color: string): Color {
    const lowercaseColor = color?.toLowerCase();
    if (lowercaseColor === 'transparent') {
        return Color.Transparent;
    }
    if (lowercaseColor?.startsWith('#')) {
        return convertHexColor(lowercaseColor);
    }
    if (lowercaseColor?.startsWith('rgba(')) {
        const colorContent = lowercaseColor.match(/rgba\((.*)\)/)?.[1];
        if (colorContent) {
            const [r, g, b, a] = colorContent.split(',').map(d => Number(d)) as number[];
            return Color.fromRGBA(r, g, b, a);
        }
    }
    if (lowercaseColor?.startsWith('rgb(')) {
        const colorContent = lowercaseColor.match(/rgb\((.*)\)/)?.[1];
        if (colorContent) {
            const [r, g, b] = colorContent.split(',').map(d => Number(d)) as number[];
            return Color.fromRGB(r, g, b);
        }
    }
    return Color.Black;
}

function convertHexColor(color: string): Color {
    const colorContent = color.slice(1);
    const { length } = colorContent;
    if (length === 6) {
        return Color.fromHex(color);
    }
    if (length === 8) {
        return Color.fromHex8(color);
    }
    if (length === 3) {
        const [r, g, b] = colorContent;
        const colorString = `#${r}${r}${g}${g}${b}${b}`;
        return Color.fromHex(colorString);
    }
    if (length === 4) {
        const [r, g, b, a] = colorContent;
        const colorString = `#${r}${r}${g}${g}${b}${b}${a}${a}`;
        return Color.fromHex8(colorString);
    }
    return Color.Black;
}
